import { Content } from '../../types';

export const cuChiTunnelsContent: Content = {
  title:
    "מנהרות קוצ'י - Cu Chi Tunnels מבוך תת-קרקעי של ההיסטוריה וההתנגדות הוייטנאמית",
  imageUrl: '/images/vietnam/cu-chi-tunnels/cu-chi-tunnels-wide.jpeg',
  introduction:
    'מנהרות קוצ\'י (Cu Chi Tunnels) הינן מערכת מנהרות תת-קרקעיות באורך של יותר מ-250 ק"מ, שנבנו על ידי הווייטקונג במהלך מלחמת וייטנאם. הן שוכנות כ-50 ק"מ צפונית-מערבית להו צ\'י מין סיטי (סייגון) ושימשו כמבצר אסטרטגי של לוחמי הגרילה במאבקם נגד הכוחות האמריקאיים והדרום-וייטנאמים.',
  sections: [
    {
      title: 'היסטוריה ורקע',
      type: 'text',
      content:
        'המנהרות החלו להיבנות עוד בתקופת השלטון הקולוניאלי הצרפתי, אך פותחו והורחבו משמעותית במהלך המלחמה נגד ארה"ב בשנות ה-60 וה-70. הן שימשו כבסיסים מוסווים, נתיבי תקשורת, מחסני נשק ומגורים ואף כללו בתי חולים, מטבחים ומתקני ייצור נשק.',
    },
    {
      title: 'מבנה ומאפיינים',
      type: 'list',
      content: [
        {
          subtitle: 'רשת מפוצלת',
          text: 'המנהרות חולקו לרמות שונות של עומק – חלקן רדודות (כ-3 מטרים) וחלקן הגיעו אף לעומק של 10 מטרים ויותר.',
        },
        {
          subtitle: 'מנגנוני הסוואה',
          text: 'הכניסות הוסתרו באמצעות צמחייה טבעית, ומנגנוני ההסוואה כללו גם מלכודות מסמרי במבוק קטלניות ("מלכודות פונגי").',
        },
        {
          subtitle: 'מערכת אוורור',
          text: 'חורים זעירים שימשו לאוורור המנהרות והוסוו כך שלא יתגלו על ידי האויב.',
        },
        {
          subtitle: 'חיים בתנאים קשים',
          text: 'הלוחמים סבלו ממחלות, חוסר חמצן וחרקים רעילים, אך ניהלו חיים שלמים מתחת לפני הקרקע.',
        },
      ],
    },
    {
      title: 'תפקידן במלחמה',
      type: 'text',
      content:
        'המנהרות שימשו בסיס יציאה לפעולות גרילה, מארבים והתנגדות עיקשת לאמריקאים, שפיתחו טקטיקות שונות כדי להתמודד עם הלוחמים התת-קרקעיים. יחידות מיוחדות, כמו "עכברי מנהרות" (Tunnel Rats), נשלחו לתוך המנהרות, אך נתקלו בהתנגדות קשה ובתנאים מסוכנים.',
    },
    {
      title: 'האתר כיום',
      type: 'text',
      content:
        "מנהרות קוצ'י, כיום, הינן אתר היסטורי פופולרי לתיירים, בו המבקרים יכולים להיכנס למנהרות (בגרסה מרווחת יותר לתיירים) ולחוות את החיים מתחת לאדמה, לצפות במלכודות ושיטות לחימה של הווייטקונג, לנסות ירי ברובים אותנטיים כגון AK-47 במטווח סמוך וללמוד על ההיסטוריה באמצעות סרטונים, תצוגות ודגמים של חיי הלוחמים.",
    },
    {
      title: 'מידע שימושי',
      type: 'text',
      content:
        "האתר ממוקם כשעה-שעתיים נסיעה מהו צ'י מין סיטי, ונגיש באמצעות סיורי חצי יום מאורגנים, מוניות או אופנועים.",
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'זהו אתר חובה לכל חובבי ההיסטוריה ומבקרים המעוניינים להבין את שיטות הלחימה וההקרבה של הווייטקונג במלחמת וייטנאם.',
    },
  ],
};
